import { useRef, useEffect } from 'react';
import { extrema } from '@clear-coat/mo_svg/src/utils/shapes';
import { scale } from '@utils/canvas';
import { checkIsHighlight } from '@utils/designs';
import { useStyles } from './styles/SVGPreview.styles';

import type { Shapes } from '@clear-coat/mo_svg/src';
import type { HighlightIndex } from '@utils/designs';

interface SVGPreviewProps {
    svgShapes: Shapes;
    highlightIndexes: HighlightIndex[];
}

export const SVGPreview = ({ svgShapes, highlightIndexes }: SVGPreviewProps) => {
    const styles = useStyles();

    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const canvas = canvasRef.current;

        if (!canvas) {
            return;
        }

        const context = canvas.getContext('2d') as CanvasRenderingContext2D;

        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        context.clearRect(0, 0, 1000, 1000);

        const { xMaxima, xMinima, yMaxima, yMinima } = extrema(svgShapes);

        scale(canvas, context, xMaxima, xMinima, yMaxima, yMinima);

        svgShapes.forEach((shape, shapeIdx) => {
            shape.forEach((point, pointIdx) => {
                if (pointIdx === 0) {
                    return;
                }

                const lastPoint = shape[pointIdx - 1];

                context.beginPath();

                if (checkIsHighlight(highlightIndexes, shapeIdx, pointIdx)) {
                    context.strokeStyle = 'red';
                    context.rect(point[0] - 5, point[1] - 5, 10, 10);
                }

                context.closePath();

                context.stroke();

                context.strokeStyle = 'black';
                context.lineWidth = 1;

                context.beginPath();

                context.moveTo(...lastPoint);

                context.lineTo(...point);

                context.closePath();

                context.stroke();
            });
        });

        context.resetTransform();
    }, [svgShapes]);

    return <canvas ref={canvasRef} className={styles.canvas} />;
};
